var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsCrowdenergy179(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 99.2 99.2",
    style: {
      enableBackground: "new 0 0 99.2 99.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_50"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF00",
    d: "M49.6,14.6c-19.3,0-35,15.6-35,35c0,19.3,15.6,35,35,35c19.3,0,35-15.6,35-35S68.9,14.6,49.6,14.6z  M72.9,72.8c-6,6-14.2,9.7-23.3,9.7s-17.3-3.7-23.3-9.7s-9.7-14.2-9.7-23.3s3.7-17.3,9.7-23.3s14.2-9.7,23.3-9.7 s17.3,3.7,23.3,9.7s9.7,14.2,9.7,23.3C82.6,58.6,78.9,66.8,72.9,72.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF00",
    d: "M51.7,30.1c4.2,0,8,1.3,11.2,3.6c0.5,0.3,1.1,0.2,1.4-0.2c0.3-0.5,0.2-1.1-0.2-1.4l0,0 c-3.5-2.5-7.7-3.9-12.3-3.9c-10.5,0-19.2,7.5-21,17.5h-2.5c-0.6,0-1,0.4-1,1s0.4,1,1,1h2.3c-0.1,0.6-0.1,1.3-0.1,1.9 c0,0.6,0,1.3,0.1,1.9h-2.3c-0.6,0-1,0.4-1,1s0.4,1,1,1h2.4c1.8,9.8,10.5,17.4,21,17.4c4.6,0,8.8-1.5,12.3-3.9 c0.5-0.3,0.6-0.9,0.2-1.4c-0.3-0.5-0.9-0.6-1.4-0.2c-3.1,2.1-7,3.5-11.1,3.5c-5.4,0-10.2-2.2-13.7-5.7c-2.6-2.6-4.5-6-5.3-9.8H58 c0.6,0,1-0.4,1-1s-0.4-1-1-1H32.4c-0.1-0.6-0.1-1.3-0.1-1.9c0-0.6,0-1.3,0.1-1.9H58c0.6,0,1-0.4,1-1s-0.4-1-1-1H32.7 c0.8-3.8,2.7-7.2,5.3-9.8C41.5,32.3,46.3,30.1,51.7,30.1z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "podklad"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF00",
    d: "M89.6,4c3.1,0,5.6,2.5,5.6,5.6v80c0,3.1-2.5,5.6-5.6,5.6h-80c-3.1,0-5.6-2.5-5.6-5.6v-80C4,6.5,6.5,4,9.6,4 H89.6 M89.6,0h-80C4.3,0,0,4.3,0,9.6v80c0,5.3,4.3,9.6,9.6,9.6h80c5.3,0,9.6-4.3,9.6-9.6v-80C99.2,4.3,94.9,0,89.6,0L89.6,0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCrowdenergy179);
export default __webpack_public_path__ + "static/media/icons-crowdenergy-179.717f928287b1cba85917dd27ad46bc37.svg";
export { ForwardRef as ReactComponent };